
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(12(29|9073)|226771|36309|380456|842619|99375)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
